import {combineReducers} from 'helpers';
import * as reducers from './reducers';

const combined = combineReducers(reducers);

export function rootReducer(state: ReturnType<typeof combined>, action: any) {
  switch (action.type) {
    case 'SESSION_RESET':
    case 'SESSION_LOGOUT':
      return combined(undefined, action);

    default:
      return combined(state, action);
  }
}
